module.exports = __webpack_public_path__ + "static/4-41c3e7166d81d06400104db66fcf3ac0.jpg";